import makeStyles from "utils/makeStyles";

export default makeStyles(theme => ({
    wrapper: {
        
    },
    header: {
        padding: "10px 20px",
    },
    headerToolbar:{
        backgroundColor:theme.palette.primary.main,
        color:"white"
    },
    toolbar: {
        padding: "10px 20px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        overflowX:'auto',
    },
    crudButtons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight:10
    },
    content: {
        padding: "10px 20px",
    },
}));